import { defineMessages, useIntl } from 'react-intl';
import config from '@plone/volto/registry';
import type { BlocksFormData, JSONSchema } from '@plone/types';
import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';
import { addFormWidth } from './formSchemaWidth';

const messages = defineMessages({
  blockWidth: {
    id: 'Block Width',
    defaultMessage: 'Block Width',
  },
  redirectTarget: {
    id: 'form_redirect_target',
    defaultMessage: 'Danke-Seite',
  },
  redirectTargetDescription: {
    id: 'form_redirect_target_description',
    defaultMessage:
      'Nach erfolgreichem Absenden wird zu dieser Seite weitergeleitet.',
  },
});

const FORM_WIDTHS = ['narrow', 'default'];

export type FormSchema = (data: BlocksFormData) => JSONSchema;

export default function withFormWidth(BaseFormSchema: FormSchema): FormSchema {
  return function FormSchema(data: BlocksFormData): JSONSchema {
    const intl = useIntl();
    const schema = BaseFormSchema(data);

    const defaultFieldset = schema.fieldsets.find(
      (fieldset) => fieldset.id === 'default',
    );
    defaultFieldset?.fields.push('redirect_target');
    schema.properties.redirect_target = {
      title: intl.formatMessage(messages.redirectTarget),
      description: intl.formatMessage(messages.redirectTargetDescription),
      widget: 'object_browser',
      mode: 'link',
      allowExternals: false,
      selectedItemAttrs: ['Title', 'Description'],
    };

    addStyling({ schema, intl });

    return addFormWidth(
      schema,
      intl.formatMessage(messages.blockWidth),
      config.blocks.widths
        .filter((width) => FORM_WIDTHS.includes(width.name))
        .map((width) => width.name),
    );
  };
}
